import React from 'react'
import { useSelector } from 'react-redux'

import CreateForm from './components/Step1/Form'
import Head from './components/Head'
import Calendar from './components/Step2/Calendar'
import FinalizeScreen from './components/Step3/FinalizeScreen'

import { selectStepCreateBanner } from 'routing/fetchingfunction/user/user.reducer'

const CreateBanners = ({ onFinalize, className = '' }) => {
  const step = useSelector(selectStepCreateBanner)

  const content = () => {
    switch (step) {
      case 1:
        return <CreateForm />
      case 2:
        return <FinalizeScreen onFinalize={onFinalize} />
      // case 2:
      // return (
      //   <div className="w-full">
      //     <Calendar />
      //   </div>
      // )
      case 3:
        return <FinalizeScreen onFinalize={onFinalize} />
      default:
        return <CreateForm />
    }
  }

  return (
    <div
      className={`
    rounded-lg text-[#F67443] mx-auto my-8 flex flex-col items-center justify-start ${className}
    ${step !== 2 ? 'bg-[#FEEBDD]' : ''}
    ${
      step === 1
        ? 'w-full max-w-[800px] px-4 sm:px-6  md:px-[148px] py-10 sm:py-12 lg:py-16'
        : 'w-full max-w-5xl px-4 sm:px-6 md:px-8 py-8'
    }
  `}
    >
      {' '}
      {step !== 2 && <Head />}
      {content()}
    </div>
  )
}

export default React.memo(CreateBanners)
